import { Provider } from '@angular/core';
import { ProductTypes } from 'products-data';
import { provideItemResultComponent, provideProductResultComponent } from 'products-ui';
import { PunchoutItemResultLayoutComponentsProviderComponent } from 'punchout-ui';
import { PunchoutProductResultLayoutComponentsProviderComponent } from 'punchout-ui';

export function providePunchoutPromoRibbonFeature(): Provider[] {
  return [
    provideItemResultComponent({
      type: ProductTypes.Standard,
      component: PunchoutItemResultLayoutComponentsProviderComponent,
    }),
    provideItemResultComponent({
      type: ProductTypes.Wire,
      component: PunchoutItemResultLayoutComponentsProviderComponent,
    }),
    provideProductResultComponent({
      type: ProductTypes.Standard,
      component: PunchoutProductResultLayoutComponentsProviderComponent,
    }),
  ];
}
